import Vue from 'vue'
import Router from 'vue-router'
import { siteAsyncRoutes } from './modules/site'
import routerEnvConfig from './setup/siteRouterEnv'
import { siteName } from '@/utils/constant'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

routerEnvConfig.set()

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/icons',
    component: () => import('@/views/icons/index.vue'),
    hidden: true
  },
  {
    path: '/login',
    component: () => import('@/views/site/login/index'),
    name: 'Site-Login',
    meta: {
      title: siteName + ' - 登录',
      siteTitle: siteName
    }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/admin-insurance-product'
  }
]
/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = []

for (const subRoute of siteAsyncRoutes) {
  asyncRoutes.push(subRoute)
}

// 404 page must be placed at the end !!!
asyncRoutes.push({ path: '*', redirect: '/404', hidden: true })

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
